export const BASE_PAGE = {
  APP_SETTINGS: "app-setting",
  BANNER: "banner",
  SELECT_CLIENT: "select-client",
  SELECT_AUTH: "select-auth",
  BULK_UPLOAD: "bulk-upload",
  LOCATION_GROUP: "location_group",
  NOTIFICATION: "notification",
  PROMOTION: "offer",
  STORE: "store",
  FILE: "file",
  FILE_MANAGER: "filemanager",
  SYPI_DB: "sypi-db-config",
  SYPI: "sypi",
  SYPI_LEGACY: "sypi-legacy",
  DASHBOARD: "dashboard",
  BUILD_DETAILS: "build-detail",
  PN_TESTING_TOOL: "pn-testing",
  C3_CLIENT: "c3-client",
  C3_CLIENT_GROUP: "c3-client-group",
  SCHEMA_MANAGEMENT: "schema-management",
  LOGGED_OUT: "logged-out",
  DTP: "dtp",
  ROOT: "root"
};

export const ERROR_TYPES = {
  //Future opportunity to standardize all error types
  CURRENT_SAME_AS_MIN: "currentSameAsMin",
  CURRENT_BEFORE_MIN: "currentBeforeMin",
};

export const ACTIONS_CONSTANTS = {
  //Sypi
  UPDATE_SCHEDULED: "updateScheduled",
  SCHEDULED_SUMMARY: "scheduledSummary",
  SUBMIT_SUMMARY: "submitSummary",
  UPDATE_DRAFT: "updateDraft",
  DRAFT_SUMMARY: "draftSummary",
};

export const STATE_CONTANTS = {
  //Global
  CREATE: "create",
  SUMMARY: "summary",
  FORM: "form",
  SCHEDULED_STATUS: "scheduled",
  DRAFT_STATUS: "draft",
  COMPLETED_STATUS: "completed",
  SCHEDULER_STATUS: "scheduledDraft",
  GENERAL_SCHEDULER_STATUS: "generalScheduledDraft",
  GENERAL_SCHEDULER_ERROR: "generalScheduledDraftError",
  DISPLAY_IMPORT_SUMMARY: "displayImportSummary",
  DISPLAY_CONFIG_SCHEDULER_SUMMARY: "displayConfigSchedulerSummary",
  DISPLAY_UPDATE_DEFAULTS_SUMMARY: "displayUpdateSchemaDefaults",
  DISPLAY_RESET_SUMMARY: "displayResetSummary",
  DISPLAY_REVERT_SUMMARY: "displayRevertSummary",
};

export const SYPI_ERROR_TYPES = {
  ADDITIONAL_PROPERTIES: "additionalProperties",
  TYPE: "type",
  REQUIRED: "required",
  MINIMUM_LENGTH: "minLength",
};

export const BROWSER_CONSTANTS = {
  JWT_TOKEN: "jwt",
  MINIMUM_PROPERTIES: "minProperties",
};

export const API_METHODS = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
  PATCH: "PATCH",
  PUT: "PUT",
};

export const EMPTY_FILE_VERSIONS = "There are currently no older files.";

/**
 * Maximum allowed file size for uploads in the file manager, in bytes.
 * Update in one place if the backend limit changes.
 */
export const MAX_FILE_UPLOAD_BYTES = 10 * 1024 * 1024;
export const MAX_FILE_UPLOAD_LABEL = "10 MB";
export const MIN_SCHEDULE_WINDOW_MINUTES = 2;

export const REGEX_CONSTANTS = {
  APP_SIDE: {
    HEX_CODE: "^#([A-Fa-f0-9]{6})$",
    LINK: "^(?:$|https?://(?:www\\.)?[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}(?:/[^\\s]*)?)$",
    NUMBER: "^\\d+$",
    STRING:
      "^[a-zA-Z0-9\\s.,=`'’_!?()\\[\\]{};:'\"%*$@#&+-/àáâãäåèéêëìíîïðñòóôõöøùúûüýÿ®]+$",
  },
};

export const regexErrorMessages = {
  [REGEX_CONSTANTS.APP_SIDE.HEX_CODE]: "Not a valid color code",
  [REGEX_CONSTANTS.APP_SIDE.LINK]: "Not a valid link",
  [REGEX_CONSTANTS.APP_SIDE.NUMBER]: "Not a valid number",
  [REGEX_CONSTANTS.APP_SIDE.STRING]: "Not a valid string",
};

